var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBlockChatRoom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBlockChatRoom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.6681368,4.00416816 C21.6672987,4.00333006 21.66674,4.00221259 21.6659019,4.00109512 C21.6645051,3.99969828 21.6628289,3.99858082 21.6614321,3.99718398 C20.4163134,2.65231092 18.8613816,1.56473494 17.0578172,0.861847399 C16.5761963,0.673553996 16.0775342,0.513756034 15.5760785,0.386923386 C14.5645068,0.130185053 13.5272338,0 12.4930338,0 C6.77504188,0 1.79791936,3.87593867 0.389373569,9.42528607 C-0.431952217,12.6614742 0.055535367,16.0233774 1.76216095,18.8916391 C3.46906591,21.7601801 6.19117423,23.7920168 9.42730957,24.6130766 C10.4391606,24.8698149 11.476713,25 12.5111923,25 C16.4803749,25 20.2506514,23.0832626 22.5970171,19.8724969 C23.5395862,18.5823798 24.2189959,17.1363758 24.6154113,15.5738758 C25.6864872,11.3531982 24.4620413,7.02691981 21.6681368,4.00416816 Z M1.74288494,9.76918693 C2.99414963,4.83975505 7.41478203,1.3971147 12.4927544,1.3971147 C13.411019,1.3971147 14.3329153,1.51277266 15.2330213,1.74129492 C15.6788839,1.85387985 16.1213941,1.99579832 16.5493775,2.16313919 C17.9204887,2.69784776 19.1284522,3.48342795 20.1422587,4.44724432 L3.79508196,19.3850013 C3.49476726,19.0033859 3.21484602,18.6019355 2.96258167,18.1775769 C1.44648132,15.6297492 1.01346942,12.6435947 1.74288494,9.76918693 Z M23.2616205,15.2305337 C22.9090651,16.6187087 22.3059214,17.9032384 21.4692307,19.0486434 C19.3851863,21.9007018 16.0364679,23.603444 12.5114717,23.603444 C11.5926484,23.603444 10.6707521,23.4875067 9.77120482,23.2592638 C7.83717815,22.7686952 6.11155591,21.7892343 4.72647657,20.4262024 L21.0923706,5.47140399 C23.2524016,8.11952441 24.1533457,11.7155373 23.2616205,15.2305337 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_VideoMembers-Copy-2",
    transform: "translate(-18.000000, -590.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-10",
    transform: "translate(18.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey-copy",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icBlockChatRoom",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockChatRoom);
export default __webpack_public_path__ + "static/media/icBlockChatRoom.4e2a5f32449809eebcbcce79bcfa7cef.svg";
export { ForwardRef as ReactComponent };